// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompanyAccount-page-nZPie {
  min-height: 70vh;
  background: #faf7f7;
  font-family: 'Poppins', system-ui, -apple-system, sans-serif;
  padding-bottom: 48px;
}

.CompanyAccount-topbar-tsbnb {
  background: #fff;
  border-bottom: 1px solid #f0e6e6;
}

.CompanyAccount-wrap-lmyR6 {
  max-width: 880px;
  margin: 0 auto;
  padding: 0 20px;
}

.CompanyAccount-eyebrow-uD4Ts {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.4px;
  color: #d32f2f;
  text-transform: uppercase;
}

.CompanyAccount-title-c_upF {
  font-size: 26px;
  font-weight: 800;
  color: #1f2733;
  margin: 4px 0 18px;
}

.CompanyAccount-body-i5Uyw {
  padding-top: 26px;
}

.CompanyAccount-card-ABQkU {
  background: #fff;
  border: 1px solid #f0e0e0;
  border-radius: 16px;
  padding: 22px;
  margin-bottom: 16px;
  -webkit-box-shadow: 0 6px 16px rgba(0, 0, 0, 0.03);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.03);
}

.CompanyAccount-cardTitle-hZHqD {
  font-size: 16px;
  font-weight: 800;
  color: #1f2733;
  margin: 0 0 4px;
}

.CompanyAccount-cardSub-Y5amp {
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 16px;
}

/* Referral */

.CompanyAccount-referralCard-yZLaW {
  background: #fff6f4;
  border: 1px solid #f1d3cb;
  border-radius: 16px;
  padding: 22px;
  margin-bottom: 16px;
}

.CompanyAccount-referralCode-vyZZj {
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 3px;
  color: #d32f2f;
  margin: 10px 0;
}

.CompanyAccount-btnRow-Yi7Sj {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 12px;
  margin-top: 14px;
}

.CompanyAccount-btnOutline-fPftf {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid #d32f2f;
  background: #fff;
  color: #d32f2f;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}

.CompanyAccount-btnPrimary-Z0UNm {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  padding: 12px 16px;
  border-radius: 12px;
  border: none;
  background: #d32f2f;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}

.CompanyAccount-btnPrimary-Z0UNm:disabled {
  opacity: 0.6;
  cursor: default;
}

/* Specialties chips */

.CompanyAccount-chips-vHR07 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 10px;
}

.CompanyAccount-chip-Ho9cp {
  padding: 10px 16px;
  border-radius: 24px;
  border: 1px solid #f0e0e0;
  background: #fdf3f1;
  color: #1f2733;
  font-weight: 700;
  font-size: 13.5px;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.CompanyAccount-chipOn-vp423 {
  background: #d32f2f;
  border-color: #d32f2f;
  color: #fff;
}

.CompanyAccount-saveRow-KHt2k {
  margin-top: 18px;
}

/* Menu rows */

.CompanyAccount-row-q6_U3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #f4ecec;
  cursor: pointer;
  text-decoration: none;
  color: #1f2733;
}

.CompanyAccount-row-q6_U3:last-child {
  border-bottom: none;
}

.CompanyAccount-rowMain-nQGYY {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.CompanyAccount-rowTitle-KAw0x {
  font-size: 14.5px;
  font-weight: 700;
  color: #1f2733;
}

.CompanyAccount-rowSub-eJu5q {
  font-size: 12.5px;
  color: #6b7280;
  margin-top: 2px;
}

.CompanyAccount-chevron-eKMud {
  color: #b8b0b0;
  font-size: 20px;
}

.CompanyAccount-danger-DomkB {
  color: #b00020;
}

.CompanyAccount-loading-qdDkP {
  padding: 80px 0;
  text-align: center;
  color: #6b7280;
  font-size: 15px;
}

.CompanyAccount-kv-QHU7j {
  font-size: 14px;
  color: #1f2733;
  font-weight: 600;
}

/* Business section */

.CompanyAccount-bizBlock-hYzXC {
  border-top: 1px solid #f4ecec;
  padding-top: 14px;
  margin-top: 14px;
}

.CompanyAccount-bizBlock-hYzXC:first-of-type {
  border-top: none;
  padding-top: 0;
  margin-top: 4px;
}

.CompanyAccount-bizHead-xsj_O {
  font-size: 13.5px;
  font-weight: 800;
  color: #1f2733;
  margin-bottom: 10px;
}

.CompanyAccount-bizRow-ZsnGE {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.CompanyAccount-bizK-G9Ou3 {
  width: 130px;
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
  font-size: 12.5px;
  font-weight: 600;
  color: #6b7280;
}

.CompanyAccount-bizV-V_YlV {
  font-size: 13px;
  font-weight: 600;
  color: #1f2733;
}

.CompanyAccount-bizEmpty-EROKM {
  font-size: 12.5px;
  color: #6b7280;
}

.CompanyAccount-docRow-kMuCK {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.CompanyAccount-docMain-xrCkC {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.CompanyAccount-docTitle-CmDvJ {
  font-size: 13.5px;
  font-weight: 700;
  color: #1f2733;
}

.CompanyAccount-docSub-ZLcCB {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.CompanyAccount-pill-jgA2Q {
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  background: #f3e8e8;
  color: #8a6d3b;
}

.CompanyAccount-pillOk-Cfr1r {
  background: #e6f4ea;
  color: #2e7d32;
}
`, "",{"version":3,"sources":["webpack://./src/routes/company-account/CompanyAccount.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kDAA0C;UAA1C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;;AACb;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,sBAAsB;;AACtB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAiB;KAAjB,sBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;;AACd;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;;AACrB;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAU;MAAV,cAAU;UAAV,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAU;MAAV,cAAU;UAAV,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".page {\n  min-height: 70vh;\n  background: #faf7f7;\n  font-family: 'Poppins', system-ui, -apple-system, sans-serif;\n  padding-bottom: 48px;\n}\n\n.topbar {\n  background: #fff;\n  border-bottom: 1px solid #f0e6e6;\n}\n\n.wrap {\n  max-width: 880px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.eyebrow {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  color: #d32f2f;\n  text-transform: uppercase;\n}\n\n.title {\n  font-size: 26px;\n  font-weight: 800;\n  color: #1f2733;\n  margin: 4px 0 18px;\n}\n\n.body {\n  padding-top: 26px;\n}\n\n.card {\n  background: #fff;\n  border: 1px solid #f0e0e0;\n  border-radius: 16px;\n  padding: 22px;\n  margin-bottom: 16px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.03);\n}\n\n.cardTitle {\n  font-size: 16px;\n  font-weight: 800;\n  color: #1f2733;\n  margin: 0 0 4px;\n}\n\n.cardSub {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0 0 16px;\n}\n\n/* Referral */\n.referralCard {\n  background: #fff6f4;\n  border: 1px solid #f1d3cb;\n  border-radius: 16px;\n  padding: 22px;\n  margin-bottom: 16px;\n}\n\n.referralCode {\n  font-size: 30px;\n  font-weight: 800;\n  letter-spacing: 3px;\n  color: #d32f2f;\n  margin: 10px 0;\n}\n\n.btnRow {\n  display: flex;\n  gap: 12px;\n  margin-top: 14px;\n}\n\n.btnOutline {\n  flex: 1;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid #d32f2f;\n  background: #fff;\n  color: #d32f2f;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.btnPrimary {\n  flex: 1;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: none;\n  background: #d32f2f;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.btnPrimary:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* Specialties chips */\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.chip {\n  padding: 10px 16px;\n  border-radius: 24px;\n  border: 1px solid #f0e0e0;\n  background: #fdf3f1;\n  color: #1f2733;\n  font-weight: 700;\n  font-size: 13.5px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.chipOn {\n  background: #d32f2f;\n  border-color: #d32f2f;\n  color: #fff;\n}\n\n.saveRow {\n  margin-top: 18px;\n}\n\n/* Menu rows */\n.row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 0;\n  border-bottom: 1px solid #f4ecec;\n  cursor: pointer;\n  text-decoration: none;\n  color: #1f2733;\n}\n\n.row:last-child {\n  border-bottom: none;\n}\n\n.rowMain {\n  display: flex;\n  flex-direction: column;\n}\n\n.rowTitle {\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #1f2733;\n}\n\n.rowSub {\n  font-size: 12.5px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.chevron {\n  color: #b8b0b0;\n  font-size: 20px;\n}\n\n.danger {\n  color: #b00020;\n}\n\n.loading {\n  padding: 80px 0;\n  text-align: center;\n  color: #6b7280;\n  font-size: 15px;\n}\n\n.kv {\n  font-size: 14px;\n  color: #1f2733;\n  font-weight: 600;\n}\n\n/* Business section */\n.bizBlock {\n  border-top: 1px solid #f4ecec;\n  padding-top: 14px;\n  margin-top: 14px;\n}\n\n.bizBlock:first-of-type {\n  border-top: none;\n  padding-top: 0;\n  margin-top: 4px;\n}\n\n.bizHead {\n  font-size: 13.5px;\n  font-weight: 800;\n  color: #1f2733;\n  margin-bottom: 10px;\n}\n\n.bizRow {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.bizK {\n  width: 130px;\n  flex: none;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.bizV {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2733;\n}\n\n.bizEmpty {\n  font-size: 12.5px;\n  color: #6b7280;\n}\n\n.docRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.docMain {\n  display: flex;\n  flex-direction: column;\n}\n\n.docTitle {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #1f2733;\n}\n\n.docSub {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.pill {\n  flex: none;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  background: #f3e8e8;\n  color: #8a6d3b;\n}\n\n.pillOk {\n  background: #e6f4ea;\n  color: #2e7d32;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `CompanyAccount-page-nZPie`,
	"topbar": `CompanyAccount-topbar-tsbnb`,
	"wrap": `CompanyAccount-wrap-lmyR6`,
	"eyebrow": `CompanyAccount-eyebrow-uD4Ts`,
	"title": `CompanyAccount-title-c_upF`,
	"body": `CompanyAccount-body-i5Uyw`,
	"card": `CompanyAccount-card-ABQkU`,
	"cardTitle": `CompanyAccount-cardTitle-hZHqD`,
	"cardSub": `CompanyAccount-cardSub-Y5amp`,
	"referralCard": `CompanyAccount-referralCard-yZLaW`,
	"referralCode": `CompanyAccount-referralCode-vyZZj`,
	"btnRow": `CompanyAccount-btnRow-Yi7Sj`,
	"btnOutline": `CompanyAccount-btnOutline-fPftf`,
	"btnPrimary": `CompanyAccount-btnPrimary-Z0UNm`,
	"chips": `CompanyAccount-chips-vHR07`,
	"chip": `CompanyAccount-chip-Ho9cp`,
	"chipOn": `CompanyAccount-chipOn-vp423`,
	"saveRow": `CompanyAccount-saveRow-KHt2k`,
	"row": `CompanyAccount-row-q6_U3`,
	"rowMain": `CompanyAccount-rowMain-nQGYY`,
	"rowTitle": `CompanyAccount-rowTitle-KAw0x`,
	"rowSub": `CompanyAccount-rowSub-eJu5q`,
	"chevron": `CompanyAccount-chevron-eKMud`,
	"danger": `CompanyAccount-danger-DomkB`,
	"loading": `CompanyAccount-loading-qdDkP`,
	"kv": `CompanyAccount-kv-QHU7j`,
	"bizBlock": `CompanyAccount-bizBlock-hYzXC`,
	"bizHead": `CompanyAccount-bizHead-xsj_O`,
	"bizRow": `CompanyAccount-bizRow-ZsnGE`,
	"bizK": `CompanyAccount-bizK-G9Ou3`,
	"bizV": `CompanyAccount-bizV-V_YlV`,
	"bizEmpty": `CompanyAccount-bizEmpty-EROKM`,
	"docRow": `CompanyAccount-docRow-kMuCK`,
	"docMain": `CompanyAccount-docMain-xrCkC`,
	"docTitle": `CompanyAccount-docTitle-CmDvJ`,
	"docSub": `CompanyAccount-docSub-ZLcCB`,
	"pill": `CompanyAccount-pill-jgA2Q`,
	"pillOk": `CompanyAccount-pillOk-Cfr1r`
};
module.exports = ___CSS_LOADER_EXPORT___;
